import '@cell/cell-core/component/product-context';

import '@/styles/main.scss';
import './layout.scss';

// Components
import '@/components/a-plus-content/a-plus-content';
import '@/components/accordion/accordion';
import '@/components/address/address';
import '@/components/alert/alert';
import '@/components/banner/banner';
import '@/components/bestsellers/bestsellers';
import '@/components/blog-article-card/blog-article-card';
import '@/components/button/button';
import '@/components/campaign-card/campaign-card';
import '@/components/cart-drawer/cart-drawer';
import '@/components/cart-line-item/cart-line-item';
import '@/components/checkbox/checkbox';
import '@/components/collection-card/collection-card';
import '@/components/color-swatch/color-swatch';
import '@/components/content-box/content-box';
import '@/components/drawer/drawer';
import '@/components/dropdown/components/dropdown-content/dropdown-content';
import '@/components/dropdown/components/dropdown-trigger/dropdown-trigger';
import '@/components/empty-state/empty-state';
import '@/components/featured-product-card/featured-product-card';
import '@/components/feedback-indicators/skeleton/skeleton';
import '@/components/form-layout/form-layout';
import '@/components/form/form';
import '@/components/grid/grid';
import '@/components/heading/heading';
import '@/components/icon-group/icon-group';
import '@/components/icon/icon';
import '@/components/image-slider/image-slider';
import '@/components/image/image';
import '@/components/info-badge/info-badge';
import '@/components/input/input';
import '@/components/language-selector/language-selector';
import '@/components/layout-and-structure/vertical-stack/vertical-stack';
import '@/components/link-list/link-list';
import '@/components/link/link';
import '@/components/loader/loader';
import '@/components/mega-menu/mega-menu';
import '@/components/menu-drawer/menu-drawer';
import '@/components/modal/modal';
import '@/components/navigation/navigation';
import '@/components/payment-methods/payment-methods';
import '@/components/price-list/price-list';
import '@/components/product-card/product-card';
import '@/components/product-list/product-list';
import '@/components/product/product-option-selector/product-option-selector';
import '@/components/product/product-size-chart/product-size-chart';
import '@/components/product/product-variant-selector/product-variant-selector';
import '@/components/promotion-card/promotion-card';
import '@/components/quantity-selector/quantity-selector';
import '@/components/rating-stars/rating-stars';
import '@/components/rating/rating';
import '@/components/scroll-info/scroll-info';
import '@/components/seal/seal';
import '@/components/search/search';
import '@/components/section/section';
import '@/components/selling-point/selling-point';
import '@/components/share-button/share-button';
import '@/components/site-header/site-header';
import '@/components/size-banner/size-banner';
import '@/components/skeleton/product-card-skeleton/product-card-skeleton';
import '@/components/slider/slider';
import '@/components/snowflakes/snowflakes';
import '@/components/spinner/spinner';
import '@/components/stack/stack';
import '@/components/stepper/stepper';
import '@/components/summary-item/summary-item';
import '@/components/swatch-button/swatch-button';
import '@/components/table/components/cell/cell';
import '@/components/table/table';
import '@/components/tabs/tabs';
import '@/components/tag/tag';
import '@/components/team-member-card/team-member-card';
import '@/components/testimonial/testimonial';
import '@/components/text-block-with-icon/text-block-with-icon';
import '@/components/text-with-icon/text-with-icon';
import '@/components/text/text';
import '@/components/time/time';
import '@/components/toast/toast';
import '@/components/toggle/toggle';
import '@/components/upsell-card/upsell-card';
import '@/components/video/video';
import '@/components/zoom-modal/zoom-modal';

// Sections
import '@/sections/(footer)/footer/footer';
import '@/sections/(header)/announcement-bar/announcement-bar';
import '@/sections/(header)/header/header';
import '@/sections/(header)/marketing-header/marketing-header';
import '@/sections/bestsellers/bestsellers';
import '@/sections/blog-articles/blog-articles';
import '@/sections/collection-description/collection-description';
import '@/sections/featured-collections/featured-collections';
import '@/sections/featured-product/featured-product';
import '@/sections/google-maps-embed/google-maps-embed';
import '@/sections/hero/hero';
import '@/sections/html-embed/html-embed';
import '@/sections/image-slider/image-slider';
import '@/sections/important-message/important-message';
import '@/sections/product-list-section/product-list-section';
import '@/sections/product-quiz/product-quiz';
import '@/sections/sale-banner/sale-banner';
import '@/sections/seals/seals';
import '@/sections/search-results/search-results';
import '@/sections/split-hero/split-hero';

// Analytics
import { AnalyticsClient } from '@cell/analytics';

new AnalyticsClient();

// User Preferences
import { UserPreferences } from '@/scripts/modules';

new UserPreferences();

function legacyChatScript() {
  !(function (e, t, n) {
    function a() {
      var e = t.getElementsByTagName('script')[0],
        n = t.createElement('script');
      (n.type = 'text/javascript'),
        (n.async = !0),
        (n.src = 'https://beacon-v2.helpscout.net'),
        e.parentNode.insertBefore(n, e);
    }
    if (
      ((e.Beacon = n =
        function (t, n, a) {
          e.Beacon.readyQueue.push({ method: t, options: n, data: a });
        }),
      (n.readyQueue = []),
      'complete' === t.readyState)
    )
      return a();
    e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, !1);
  })(window, document, window.Beacon || function () {});

  switch (window.Shopify.locale) {
    case 'de': {
      window.Beacon('init', '3c38b38d-4ca7-4bdc-b339-5944098ccb04');

      break;
    }

    case 'en': {
      window.Beacon('init', '549c7f67-5517-4ecb-aad5-77a3e784ddcd');

      break;
    }

    // No default.
  }
}

window.addEventListener('load', () => {
  if (window.cell.template.name !== 'index') {
    legacyChatScript();
  }
});

// Cart Observer for Experiments.

(() => {
  const cartDrawerElement = document.querySelector('cart-drawer');

  if (!cartDrawerElement) return;

  const callback = () => {
    // Determine if cart is open.

    const cartDrawerActive = cartDrawerElement
      .querySelector('c-drawer')
      .classList.contains('Drawer--Active');

    window.experiments.cart.isOpen = cartDrawerActive;

    // Determine if cart has items.

    const hasItems = cartDrawerElement.querySelectorAll('cart-line-item').length > 0;

    window.experiments.cart.hasItems = hasItems;

    // Determine if upsell product is in cart.

    const upsellProductId = window.experiments.cart.upsellProduct.id;
    const upsellProductInCart = !!cartDrawerElement.querySelector(
      `cart-line-item[data-product-id="${upsellProductId}"]`,
    );

    window.experiments.cart.upsellProductInCart = upsellProductInCart;

    // Execute experiment if cart is open and has items.
    if (window.experiments.cart.isOpen && window.experiments.cart.hasItems) {
      window._conv_q = window._conv_q || [];

      // Shipping Costs Communication Experiment.
      window._conv_q.push(['executeExperiment', '100497614']);
    }

    // Execute experiment if cart is open, has items, and upsell product is not in cart.
    if (
      window.experiments.cart.isOpen &&
      window.experiments.cart.hasItems &&
      !window.experiments.cart.upsellProductInCart
    ) {
      window._conv_q = window._conv_q || [];

      window._conv_q.push(['executeExperiment', '100473150']);
    }
  };

  const cartObserver = new MutationObserver(callback);

  cartObserver.observe(cartDrawerElement, {
    childList: true,
    subtree: true,
    attributes: true,
  });
})();
